import Utilities from "../components/utils/Utilities";

// k338408860
const currentUrl = window.location.href;

// Crea un oggetto URL
const url = new URL(currentUrl);

console.log("current url", currentUrl);

// Ottieni i parametri della query
const queryParams = new URLSearchParams(url.search);

// Ottieni il valore del parametro "storeid"
const bookingID = queryParams.get("storeId")
  ? "k" + queryParams.get("storeId")
  : process.env.REACT_APP_BOOKING_ID;

const token = queryParams.get("rtoken");
const domain = queryParams.get("domain") ?? "";

const originalUrl = queryParams.get("original_url") ?? "";
console.log("Trovato booking id", bookingID);
console.log("Trovato original url", originalUrl);
console.log("Trovato token", token);
console.log("Trovato domain", domain);

const apiGetBookingData = async () => {
  return new Promise((resolve, reject) => {
    const APIToken = process.env.REACT_APP_API_TOKEN;
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + APIToken);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const uri =
      "https://api.exagonplus.com/v1/" +
      bookingID +
      "/ec_get_booking_data" +
      (domain.includes("colorami") ? "/colorami" : "/exagon");

    console.log(uri);

    fetch(uri, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        return JSON.parse(result);
      })
      .then((data) => resolve(data))
      .catch((error) => reject(error));
  });
};

const apiGetDays = async (apiKey) => {
  return new Promise((resolve, reject) => {
    const APIToken = process.env.REACT_APP_API_TOKEN;
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + APIToken);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const uri =
      "http://localhost:81/xgn/booking_apis/getDays.php?XDEBUG_SESSION_START=PHPSTORM";
    //const uri = "https://api.exagonplus.com/v1/" + apiKey + "/ec_get_booking_data";

    fetch(uri, requestOptions)
      .then((response) => {
        return response.text();
      })
      .then((result) => {
        return JSON.parse(result);
      })
      .then((data) => resolve(data))
      .catch((error) => {
        reject(error);
      });
  });
};

const loadBookingData = (apiKey) => {
  return new Promise((resolve, reject) => {
    apiGetBookingData(apiKey)
      .then((data) => {
        const services = data.data.services;
        const employees = data.data.employees;
        const preferences = data.data.preferences;
        fixEmployeesImages(employees);
        fixServicesStaff(employees, services);

        const _data = {
          services: services,
          employees: employees,
          preferences: preferences,
        };

        resolve(_data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const loadDays = (apiKey) => {
  return new Promise((resolve, reject) => {
    apiGetDays(apiKey)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// preparing data in the forms of sectors that we need to display in the UI.
function getStructuredServices(services, employees) {
  const structuredServices = [];
  // there are some services which we don't want to show to users anymore. i-e Trattamento Cute E Capelli
  // so only the visible or online services, we need to show to users.
  const onlineServices = services.filter(
    (service) => service.visible_on_line === "1"
  );

  // need to display less online_order services on top.
  // If the result is negative, a is sorted before b.
  // If the result is positive, b is sorted before a.
  // If the result is 0, no changes are done with the sort order of the two values.
  let sortedServices = onlineServices.sort((a, b) => {
    return a.online_order - b.online_order;
  });

  sortedServices.forEach((service) => {
    // new code starts.....
    service.info = service.short_description;

    // preparing sectors stats...
    let sectorExist = structuredServices.find(
      (item) => item.id_commodity_sector === service.id_commodity_sector
    );
    if (!sectorExist) {
      sectorExist = {
        id_commodity_sector: service.id_commodity_sector,
        sector_name: service.sector_name,
        categories: [],
      };
      structuredServices.push(sectorExist);
    }
    // preparing sectors ends...

    // preparing categories inside sectors starts...
    let categoryExist = sectorExist.categories.find(
      (item) => item.id_category === service.id_booking_online_category
    );
    if (!categoryExist) {
      categoryExist = {
        id_category: service.id_booking_online_category,
        category_name:
          service.booking_online_category_name !== ""
            ? service.booking_online_category_name
            : "vari / altri",
        services: [],
      };
      sectorExist.categories.push(categoryExist);
    }
    // preparing categories inside sectors ends...
    service.includedServices = [];
    categoryExist.services.push(service);
    // new code ends.....
  });
  return structuredServices;
}

// adding name and images to staff array as these are not present in staff array.
const fixServicesStaff = (employees, services) => {
  const emps = employees;
  services.forEach((service) => {
    if (service.staff.length > 0) {
      // we are updating staff and adding name and images insdie staff data as there is no
      // image and name present in the staff array.
      for (let index = service.staff.length - 1; index >= 0; index--) {
        const staffItem = service.staff[index];
        const emp = emps.find((employee) => {
          return employee.id_employee === staffItem.id_employee;
        });
        if (emp) {
          staffItem.employee_name =
            emp.employee_name.substring(0, 1).toUpperCase() +
            emp.employee_name.substring(1).toLowerCase();
          staffItem.iconJsx = emp.iconJsx;
        } else {
          // if staff does not exist in employees, remove this staff.
          service.staff.splice(index, 1);
        }
      }
    } else {
      /*service staff is empty, listing all employees-*/
      emps.forEach((employee) => {
        service.staff.push({
          id_employee: employee.id_employee,
          //employee_name: employee.employee_name,
          employee_name:
            employee.employee_name.substring(0, 1).toUpperCase() +
            employee.employee_name.substring(1).toLowerCase(),
          /*employee_name: '('+employee.id_employee + ') ' + employee.employee_name,*/
          iconJsx: employee.iconJsx,
          worker_duration: "0",
          customer_duration: "0",
          standard_sell_price: "0.0000",
        });
      });
    }
  });
};

// if image present in employees creating small image.
// else creating with first letter name in the employees data.
function fixEmployeesImages(employees) {
  employees.forEach((employee) => {
    //using source image
    if (employee.image_small !== "") {
      employee.iconJsx = (
        <img
          style={{
            width: "35px",
            height: "35px",
            marginRight: "5px",
            borderRadius: "50%",
          }}
          alt=""
          src={employee.image_small}
        />
      );
    }
    //generating avatar image
    else {
      const randomColor = Math.floor(Math.random() * 16777215).toString(16);

      employee.iconJsx = (
        <div
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "50%",
            textAlign: "center",
            marginRight: "5px",
            verticalAlign: "middle",
            paddingTop: "0px",
            alignContent: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            backgroundColor: "#" + randomColor,
            minWidth: "35px",
          }}
        >
          {employee.employee_name.substring(0, 1).toUpperCase()}
        </div>
      );
    }
  });
}

const getFreeSlots = async (
  selectedDay,
  services,
  selectedServices,
  preferences
) => {
  return new Promise((resolve, reject) => {
    if (selectedDay) {
      let month = selectedDay.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let day = selectedDay.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      const year = selectedDay.getFullYear();

      const strServices = Utilities.getSelectedServicesForApi(
        services,
        selectedServices
      );

      const strDate = year + "-" + month + "-" + day;
      const data = {
        data: {
          source_url: originalUrl,
          date: strDate,
          days: preferences.numberOfDays,
          services: strServices,
        },
      };

      const APIToken = process.env.REACT_APP_API_TOKEN;
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + APIToken);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        body: JSON.stringify(data),
      };
      const uri =
        "https://api.exagonplus.com/v1/" + bookingID + "/get_free_slots";

      fetch(uri, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          return JSON.parse(result);
        })
        .then((dataobj) => {
          const transformedData = transformFreeSlots(dataobj);
          resolve(transformedData);
        })
        //.then((data) => resolve(/*data*/apiGetFreeSlots))
        .catch((error) => reject(error));
    }
    //resolve(apiGetFreeSlots);
  });
};

const transformFreeSlots = (data) => {
  const formattedSlots = [];
  if (data) {
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        const morning = {
          name: "mattino",
          times: [],
        };
        const afternoon = {
          name: "pomeriggio",
          times: [],
        };
        const row = data[i];
        if (row.slots.length > 0) {
          row.slots.forEach((item, index) => {
            const hours = item.substring(0, 2);
            if (hours <= "12") {
              morning.times.push({ time: item, slotts: row.slotsts[index] });
            } else {
              afternoon.times.push({ time: item, slotts: row.slotsts[index] });
            }
          });
        }
        const result = [];
        result.push(morning);
        result.push(afternoon);
        const resultObject = {
          date: row.date,
          slots: result,
        };
        formattedSlots.push(resultObject);
      }
    }
  }

  return formattedSlots;
};

const doBooking = (services, selectedServices, selectedSlot, formData) => {
  return new Promise((resolve, reject) => {
    const strServices = Utilities.getSelectedServicesForApi(
      services,
      selectedServices
    );

    console.log(formData);

    const data = {
      data: {
        source_url: originalUrl,
        slot: selectedSlot,
        services: strServices,
        extra_note: formData.note,
        rtoken: token,
        customer: {
          name: formData.nameFirst + " " + formData.nameLast,
          mobile: formData.phone,
          email: formData.contactEmail,
        },
      },
    };

    const APIToken = process.env.REACT_APP_API_TOKEN;

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + APIToken);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: JSON.stringify(data),
    };
    const uri =
      "https://api.exagonplus.com/v1/" + bookingID + "/createappointment";

    fetch(uri, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        return JSON.parse(result);
      })
      .then((data) => {
        if (data.data.result === "ok") {
          resolve(data);
        } else {
          reject(data.data.errMsg);
        }
      })
      .catch((error) => reject(error));
  });
};

const confirmNumber = (formData) => {
  return new Promise((resolve, reject) => {
    const APIToken = process.env.REACT_APP_API_TOKEN;

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + APIToken);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    const uri =
      "https://api.exagonplus.com/v1/" +
      bookingID +
      "/ec_ask_code_verification/" +
      formData.phone;

    fetch(uri, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        return JSON.parse(result);
      })
      .then((data) => {
        if (data.data === true) {
          resolve(data);
        } else {
          reject(data.data.errMsg);
        }
      })
      .catch((error) => reject(error));
  });
};

const confirmCode = (formData, code) => {
  return new Promise((resolve, reject) => {
    const APIToken = process.env.REACT_APP_API_TOKEN;

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + APIToken);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    const uri =
      "https://api.exagonplus.com/v1/" +
      bookingID +
      "/ec_check_verification_code/" +
      formData.phone +
      `=${code}`;

    fetch(uri, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        return JSON.parse(result);
      })
      .then((data) => {
        if (data.data === true) {
          resolve(data);
        } else {
          reject(data.data.errMsg);
        }
      })
      .catch((error) => reject(error));
  });
};

const loadUpsellServices = (
  selectedServices,
  employees,
  setStepBetween1and2Loading
) => {
  const APIToken = process.env.REACT_APP_API_TOKEN;

  return new Promise((resolve, reject) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + APIToken);
    myHeaders.append("Content-Type", "application/json");

    const commaSeparatedServices = selectedServices
      .map(
        (item) =>
          `${item.id_service}_${
            item.idStaffItem === "" ? -1 : item.idStaffItem
          }`
      )
      .join(",");
    let payload = {
      data: {
        source_url: originalUrl,
        date: "2024-03-23",
        days: "1",
        services: commaSeparatedServices,
      },
    };

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: JSON.stringify(payload),
    };
    const uri =
      "https://api.exagonplus.com/v1/" +
      bookingID +
      "/ec_get_booking_data_upsell";

    fetch(uri, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        return JSON.parse(result);
      })
      .then((dataobj) => {
        const services = dataobj.data.services;

        // check comments on fixEmployeesImages for more detail.
        fixEmployeesImages(employees);
        // check comments on fixServicesStaff for more detail.
        fixServicesStaff(employees, services);

        const newServicesWithoutSelectedOnes = [];

        for (let i = 0; i < services.length; i++) {
          if (
            !selectedServices.some(
              (e) => e.id_service === services[i].id_service
            )
          ) {
            newServicesWithoutSelectedOnes.push(services[i]);
          }
        }

        const _data = {
          services: newServicesWithoutSelectedOnes,
        };
        setStepBetween1and2Loading(false);
        resolve(_data);
      })
      //.then((data) => resolve(/*data*/apiGetFreeSlots))
      .catch((error) => {
        setStepBetween1and2Loading(false);
        reject(error);
      });
    //resolve(apiGetFreeSlots);
  });
};

const getHostDomain = () => {
  try {
    // Tenta di ottenere l'URL del genitore (la pagina che ospita l'iframe)
    const parentUrl = window.parent.location.href;
    const parentDomain = new URL(parentUrl).hostname;
    console.log("Parent domain:", parentDomain);
    return parentDomain;
  } catch (error) {
    // Se c'è un errore (ad esempio, per restrizioni di sicurezza), usa il dominio corrente
    console.log("Couldn't access parent domain, using current domain");
    return window.location.hostname;
  }
};

export {
  confirmCode,
  confirmNumber,
  getStructuredServices,
  loadBookingData,
  getFreeSlots,
  loadDays,
  doBooking,
  loadUpsellServices,
};

// https://www.facebook.com/v15.0/dialog/oauth?app_id=946726573608245&cbt=1712133686027&channel_url=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Dfa4eedf707801cf25%26domain%3Dlocalhost%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Flocalhost%253A3000%252Ff982f5791c3a00db9%26relation%3Dopener&client_id=946726573608245&display=popup&domain=localhost&e2e=%7B%7D&fallback_redirect_uri=https%3A%2F%2Flocalhost%3A3000%2Flogin&locale=en_US&logger_id=f789d0618151c6744&origin=1&redirect_uri=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df9dcd4098e98800b2%26domain%3Dlocalhost%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Flocalhost%253A3000%252Ff982f5791c3a00db9%26relation%3Dopener%26frame%3Df7bb5e82f9fa6fc41&response_type=token%2Csigned_request%2Cgraph_domain&scope=email&sdk=joey&version=v15.0&ret=login&fbapp_pres=0&tp=unspecified&ext=1712137293&hash=Aeb35rCRNsfRL2OPtGE
